export default "<ion-button [disabled]=\"disabled\" [ngStyle]=\"{'height': height, 'border-radius': border_radius}\">{{buttonName}}</ion-button>\r\n";